import { render, staticRenderFns } from "./MailingsTable.vue?vue&type=template&id=35bb9670&"
import script from "./MailingsTable.vue?vue&type=script&lang=js&"
export * from "./MailingsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports